import { inject, provide } from '@/composition/vue/compositionApi'
import type { Optional } from '@/types'

export const useProvideInject = <T>(key: string | symbol) => ({
  provide: (value: T) => provide<T>(key, value),
  inject: (defaultValue?: T): Optional<T> => inject<Optional<T>>(key, defaultValue),
})
